module.exports = __webpack_public_path__ + "img/eq-light-belt.6d90880b.png";